import { Component, Input } from '@angular/core';
import { LoaderService } from '../service/loader.service';


@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent {
  @Input() fullscreen: boolean = false;
  isLoading = false;

  constructor(private loaderService: LoaderService) {
    this.loaderService.loading$.subscribe(status => {
      this.isLoading = status;
    });
  }
}
